import {
  MISINFORMES_SUCCESS,
  MISINFORMES_LOADING,
  MISINFORMES_ERROR,
  MISINFORMES_RESET,
  MISINFORMES_ARCHIVOBASE64,
  MISINFORMES_VISUALIZARIMAGEN,
  MISINFORMES_RESET_VISUALIZARIMAGEN,
  MISINFORMES_RESET_ARCHIVOBASE64,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "../../../../global/helpers/axiosLogin";
import { parseBackendError, logError } from "../../../../global/utils/errorHandler";

/* export const wsGetMisInformes =
  (idPacFamiliar, filtroFecha, nextStep) => (dispatch) => {
    dispatch({ type: MISINFORMES_LOADING });
    axiosInstance().then((respuesta) => {
      respuesta
        .get(`/informes/${!idPacFamiliar ? "" : idPacFamiliar}/${filtroFecha}`)
        .then((resp) => {
          dispatch({
            type: MISINFORMES_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: MISINFORMES_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  }; */
export const wsGetMisInformes =
  (idPacFamiliar, filtroFecha, nextStep) => (dispatch) => {
    dispatch({ type: MISINFORMES_LOADING });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(
          `dis/informes/${!idPacFamiliar ? "" : idPacFamiliar}/${filtroFecha}`
        )
        .then((resp) => {
          dispatch({
            type: MISINFORMES_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          const parsedError = parseBackendError(err);
          logError(err, "Obtener mis informes");

          const error = {
            detail: parsedError.userMessage,
            type: parsedError.type,
            validationErrors: parsedError.validationErrors,
            technicalDetails: parsedError.technicalDetails,
            title: parsedError.title,
            rawData: parsedError.rawData,
          };

          dispatch({ type: MISINFORMES_ERROR, payload: error });
          if (nextStep) nextStep(false, error);
        });
    });
  };

export const wsGetMisInformesSimplify =
  (idPacFamiliar, filtroFecha, nextStep) => (dispatch) => {
    dispatch({ type: MISINFORMES_LOADING });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(
          `dis/informes/simplificado/${
            !idPacFamiliar ? "" : idPacFamiliar
          }/false`
        )
        .then((resp) => {
          dispatch({
            type: MISINFORMES_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          const parsedError = parseBackendError(err);
          logError(err, "Obtener informes simplificado");

          const error = {
            detail: parsedError.userMessage,
            type: parsedError.type,
            validationErrors: parsedError.validationErrors,
            technicalDetails: parsedError.technicalDetails,
            title: parsedError.title,
            rawData: parsedError.rawData,
          };

          dispatch({ type: MISINFORMES_ERROR, payload: error });
          if (nextStep) nextStep(false, error);
        });
    });
  };

export const wsGetMisInformesImagen =
  (PacsNEW, idTurno, isMobile, nextStep) => (dispatch) => {
    dispatch({ type: MISINFORMES_LOADING });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(
          PacsNEW
            ? `dis/informes/imagen-viewer/${idTurno}/${isMobile}`
            : `/informes/imagen/${idTurno}`
        )
        .then((resp) => {
          dispatch({
            type: MISINFORMES_VISUALIZARIMAGEN,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          const parsedError = parseBackendError(err);
          logError(err, "Obtener imagen de informe");

          const error = {
            detail: parsedError.userMessage,
            type: parsedError.type,
            validationErrors: parsedError.validationErrors,
            technicalDetails: parsedError.technicalDetails,
            title: parsedError.title,
            rawData: parsedError.rawData,
          };

          dispatch({ type: MISINFORMES_ERROR, payload: error });
          if (nextStep) nextStep(false, error);
        });
    });
  };
/* export const wsGetMisInformesImagen =
  (PacsNEW, idTurno, isMobile, nextStep) => (dispatch) => {
    dispatch({ type: MISINFORMES_LOADING });
    axiosInstance().then((respuesta) => {
      respuesta
        .get(
          PacsNEW
            ? `/informes/imagenViewer/${idTurno}/${isMobile}`
            : `/informes/imagen/${idTurno}`
        )
        .then((resp) => {
          dispatch({
            type: MISINFORMES_VISUALIZARIMAGEN,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: MISINFORMES_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  }; */

/* export const wsGetInformePDF =
  (tipo, estudio, codigo, nextStep) => (dispatch) => {
    dispatch({ type: MISINFORMES_LOADING });
    axiosInstance().then((respuesta) => {
      respuesta
        .get(`/informePDF/${tipo}/${estudio}/${codigo}`)
        .then((resp) => {
          dispatch({
            type: MISINFORMES_ARCHIVOBASE64,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: MISINFORMES_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  }; */

// export const wsGetInformePDF =
//   (tipo, estudio, codigo, nextStep) => (dispatch) => {
//     dispatch({ type: MISINFORMES_LOADING });
//     axiosLogin().then((respuesta) => {
//       respuesta
//         .get(`dis/informes/pdf/${tipo}/${estudio}/${codigo}/pdf`, {
//           responseType: "blob",
//         })
//         .then((resp) => {
//           const blob = resp.data;
//           dispatch({
//             type: MISINFORMES_ARCHIVOBASE64,
//             payload: null,
//           });
//           if (nextStep) nextStep(true, { blob });
//         })
//         .catch((err) => {
//           dispatch({ type: MISINFORMES_ERROR, payload: err.data });
//           if (nextStep)
//             nextStep(false, err?.response?.data || "Error al obtener PDF");
//         });
//     });
//   };

export const wsGetInformePDF =
  (tipo, estudio, codigo, nextStep) => (dispatch) => {
    dispatch({ type: MISINFORMES_LOADING });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(`dis/informes/pdf/${tipo}/${estudio}/${codigo}/pdf`, {
          responseType: "blob",
        })
        .then((resp) => {
          const blob = resp.data; // PDF
          dispatch({ type: MISINFORMES_ARCHIVOBASE64, payload: null });
          if (nextStep) nextStep(true, { blob });
        })
        .catch(async (err) => {
          const res = err?.response;
          let message = "Error al obtener PDF";
          let payload = null;

          if (res?.data instanceof Blob) {
            const ct = String(
              res.headers?.["content-type"] || ""
            ).toLowerCase();
            if (ct.includes("application/json")) {
              // El backend devolvió JSON de error dentro de un Blob
              const text = await res.data.text();
              try {
                const json = JSON.parse(text);
                message = json.title || json.detail || message;
                payload = json;
              } catch {
                message = text || message;
                payload = { raw: text };
              }
            }
          }

          dispatch({
            type: MISINFORMES_ERROR,
            payload: payload ?? message,
          });
          if (nextStep) nextStep(false, message);
        });
    });
  };

export const misInformesReset = () => (dispatch) => {
  dispatch({
    type: MISINFORMES_RESET,
  });
};

export const visulizadorReset = () => (dispatch) => {
  dispatch({
    type: MISINFORMES_RESET_VISUALIZARIMAGEN,
  });
};
export const informePDFReset = () => (dispatch) => {
  dispatch({
    type: MISINFORMES_RESET_ARCHIVOBASE64,
  });
};
